let customIMG = document.querySelector('div.resp-stickyCustom');
document.addEventListener('DOMContentLoaded', ()=>{
  customIMG.classList.add('display--reject')
  const search_btn = document.querySelector('div.custom--search > a > svg').style.fill = "black !important";
  let image = document.querySelector('img.custom-imageSwap');
  let links = document.querySelectorAll('nav.header__inline-menu li.menu-lv-item > a.header__menu-item > span.text');
    image.setAttribute('srcset', 'https://cdn.shopify.com/s/files/1/0898/7800/3993/files/Mysthelle_Logo_2.png?v=1725255472');
    links.forEach((col)=>{
      col.style.color = "#232323";
    })
})

const search_icon = document.querySelector('div.custom--search > a > svg');
search_icon.style.fill = "#232323";

console.log('above-condition');
const contentElem = document.querySelector('div.tab__content');
let h_lists = document.querySelectorAll('li.heading-tab-link')

let input1 = document.querySelector('input#inputContent1');
let input2 = document.querySelector('input#inputContent2');
let input3 = document.querySelector('input#inputContent3');
let input4 = document.querySelector('input#inputContent4');

let list = Array.from(h_lists);
          
const arr_content = [input1.value,input2.value,input3.value,input4.value];
console.log(arr_content)
list.forEach((li, index)=>{
  li.addEventListener('click', ()=>{
    list.forEach(item => item.classList.remove('active'));
    li.classList.add('active');
    contentElem.innerHTML = arr_content[index];
  })
})